import "./WidgetRight.css"

const WidgetRight = () => {
    return (
        <div className="widgetSm">
            <span className="widgetSmTitle">New Join Members</span>
            <ul className="widgetSmList">
                <li className="widgetSmListItem">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRrL3fM4WUMEL9KUTQgSMUgz6GWwyZePnXOKVsXKvevLaF8Sxu2m6OaMlt-3VHjGaxfjo&usqp=CAU" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Fadi Ayyas</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <i className="fa fa-eye  widgetSmIcon"></i>
                        Display
                    </button>
                </li>
                <li className="widgetSmListItem">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRrL3fM4WUMEL9KUTQgSMUgz6GWwyZePnXOKVsXKvevLaF8Sxu2m6OaMlt-3VHjGaxfjo&usqp=CAU" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Fadi Ayyas</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <i className="fa fa-eye  widgetSmIcon"></i>
                        Display
                    </button>
                </li>
                <li className="widgetSmListItem">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRrL3fM4WUMEL9KUTQgSMUgz6GWwyZePnXOKVsXKvevLaF8Sxu2m6OaMlt-3VHjGaxfjo&usqp=CAU" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Fadi Ayyas</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <i className="fa fa-eye  widgetSmIcon"></i>
                        Display
                    </button>
                </li>
                <li className="widgetSmListItem">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRrL3fM4WUMEL9KUTQgSMUgz6GWwyZePnXOKVsXKvevLaF8Sxu2m6OaMlt-3VHjGaxfjo&usqp=CAU" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Fadi Ayyas</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <i className="fa fa-eye  widgetSmIcon"></i>
                        Display
                    </button>
                </li>
                <li className="widgetSmListItem">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRrL3fM4WUMEL9KUTQgSMUgz6GWwyZePnXOKVsXKvevLaF8Sxu2m6OaMlt-3VHjGaxfjo&usqp=CAU" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Fadi Ayyas</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <i className="fa fa-eye  widgetSmIcon"></i>
                        Display
                    </button>
                </li>

            </ul>
        </div>
    )
}

export default WidgetRight;